var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 191,
    viewBox: "0 0 180 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 27.1052C137.4 35.8052 144.4 50.4052 148.2 65.3052C152 80.2052 152.7 95.3052 148.3 108.805C143.9 122.305 134.4 134.205 122.8 143.805C111.2 153.405 97.4001 160.705 82.4001 161.605C67.4001 162.505 54.8001 157.005 41.3001 149.605C27.8001 142.105 13.4001 132.705 7.50006 119.505C1.60006 106.305 4.20006 89.3052 10.7001 74.7052C17.2001 60.1052 27.6001 47.9052 39.5001 38.7052C51.4001 29.5052 64.8001 23.3052 78.9001 24.2052C93.0001 25.1052 106.1 33.0052 116.5 40.2052L118.2 41.3052C119.9 42.4052 121.7 43.6052 123.4 44.9052",
    fill: "#D1D5DB",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155 140.405H5C2.23858 140.405 0 142.644 0 145.405V155.405C0 158.167 2.23858 160.405 5 160.405H155C157.761 160.405 160 158.167 160 155.405V145.405C160 142.644 157.761 140.405 155 140.405Z",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 145.405H5V155.405H155V145.405Z",
    fill: "#9CA3AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 138.405C89.9411 138.405 98 130.346 98 120.405C98 110.464 89.9411 102.405 80 102.405C70.0589 102.405 62 110.464 62 120.405C62 130.346 70.0589 138.405 80 138.405Z",
    fill: "#49758D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 126.405C83.3137 126.405 86 123.719 86 120.405C86 117.091 83.3137 114.405 80 114.405C76.6863 114.405 74 117.091 74 120.405C74 123.719 76.6863 126.405 80 126.405Z",
    fill: "#EAEDEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82 98.4052H78V106.405H82V98.4052Z",
    fill: "#49758D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9705 106.263L94.1421 103.435L88.4852 109.091L91.3137 111.92L96.9705 106.263Z",
    fill: "#49758D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102 122.405V118.405H94V122.405H102Z",
    fill: "#49758D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.142 137.376L96.9705 134.547L91.3136 128.89L88.4852 131.719L94.142 137.376Z",
    fill: "#49758D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78 142.405H82V134.405H78V142.405Z",
    fill: "#49758D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0295 134.547L65.8579 137.376L71.5148 131.719L68.6863 128.89L63.0295 134.547Z",
    fill: "#49758D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58 118.405V122.405H66V118.405H58Z",
    fill: "#49758D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.858 103.435L63.0295 106.263L68.6864 111.92L71.5148 109.091L65.858 103.435Z",
    fill: "#49758D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90 113.405C91.6569 113.405 93 112.062 93 110.405C93 108.748 91.6569 107.405 90 107.405C88.3431 107.405 87 108.748 87 110.405C87 112.062 88.3431 113.405 90 113.405Z",
    fill: "#EF4444"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30.4052C90 0.405184 120 -9.59482 130 10.4052V30.4052C120 50.4052 90 60.4052 80 30.4052Z",
    fill: "#D1D5DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130 10.4052V30.4052L100 60.4052C90 40.4052 100 10.4052 130 10.4052Z",
    fill: "#9CA3AF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130 15.4052C132.761 15.4052 135 13.1666 135 10.4052C135 7.64376 132.761 5.40518 130 5.40518C127.239 5.40518 125 7.64376 125 10.4052C125 13.1666 127.239 15.4052 130 15.4052Z",
    fill: "#49758D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65.4052C102.761 65.4052 105 63.1666 105 60.4052C105 57.6438 102.761 55.4052 100 55.4052C97.2386 55.4052 95 57.6438 95 60.4052C95 63.1666 97.2386 65.4052 100 65.4052Z",
    fill: "#49758D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80 38.4052C84.4183 38.4052 88 34.8235 88 30.4052C88 25.9869 84.4183 22.4052 80 22.4052C75.5817 22.4052 72 25.9869 72 30.4052C72 34.8235 75.5817 38.4052 80 38.4052Z",
    fill: "#49758D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100 120.405L70 75.4052L110 65.4052L100 120.405Z",
    fill: "#EF4444",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.81c584b3795ee0f47eb936b186b64666.svg";
export { ForwardRef as ReactComponent };